<!-- <div class="flex items-center justify-left sub-header w-full">
  <p class="pl-[88px]">Custom</p>
  <p class="pl-[101px] sub-path">Dashboard>Stage 2>Custom>Add Work Packages</p>
</div> -->
<!-- <app-accordion></app-accordion> -->
<div>
  <div class="package-title">Work Packages</div>

  <div
    class="flex flex-wrap items-center justify-center text-center mt-[17px] m-5"
  >
    <div
      class="manual-section1 w-full md:w-1/2 lg:w-1/2 flex flex-col mr-[40px]"
    >
      <div class="available_package">Custom Work Packages
        

        <button class="move-back-button  !w-[100px]" (click)="add()">
          + Add 
        </button>
        
        

      </div>

      <!-- <div class="w-full">
        <h3 class="columns-header pt-[27px]" style="text-align: center">
          Available Work packages
        </h3>
      </div> -->

      <!-- <label> Add Work Packages </label> -->
      <!-- <div class="flex items-center justify-start ml-[20px]">
        <input
          #inputField
          matInput
          placeholder="Enter Work Package"
          (keydown.enter)="addKeyword(inputField)"
          class="p-2 border w-[308px] h-[44px] section-input"
        />
      </div> -->
      <label class="flex  !text-[18px] !ml-[70px]">Work Packages <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="!ml-[10px] !mt-[5px]">
        <path d="M5.1494 0.884766V9.1157M5.1494 9.1157L9.26487 5.00023M5.1494 9.1157L1.03394 5.00023" stroke="#1A4971" stroke-width="1.17585" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </label>
        <table class="">
          <tbody class=" !w-full">
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
          </tbody>
        </table>
        
        
    </div>

    <div
      class="manual-section2 w-full md:w-1/2 lg:w-1/2 flex flex-col mr-[21px]"
    >
      <!-- <div class="flex items-center w-full relative">
        <h3 class="columns-header pt-[27px] absolute right-1/3 pr-5 ml-[-40px]">
          Custom Work packages
        </h3>
      </div> -->
      <div class="container-manual">
        <div class="flex w-[70%] justify-between items-center">
          <div class="available_package1">Custom Work Packages Standard</div>
         
        </div>
        
      </div>
      <label class="flex  !text-[18px] !ml-[70px]">Work Packages <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="!ml-[10px] !mt-[5px]">
        <path d="M5.1494 0.884766V9.1157M5.1494 9.1157L9.26487 5.00023M5.1494 9.1157L1.03394 5.00023" stroke="#1A4971" stroke-width="1.17585" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </label>
        <table class="">
          <tbody class=" !w-full">
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
            <tr class="!mt-4">
              <td class="flex items-start">
                <mat-icon class="!mr-[25px]">add_circle_outline</mat-icon>
                A Pre-Contract Cost Planning
              </td>
            </tr>
          </tbody>
        </table>
        
       
      <div class="packages-list pt-[27px]">
        <table class="">
          <!-- <tr class="mb-[20px]">
            <th class="w-[5%] checkbox-header w-[22.3px] h-[22.3px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M2.80554 7H10.6586"
                  stroke="#2368A2"
                  stroke-width="1.92319"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </th>
            <th class="w-[20%] pl-[23.08px]">Work Packages</th>
            <th class="5%">
              <mat-icon>arrow_downward</mat-icon>
            </th>
            <th class="w-[70%]"></th>
          </tr> -->

          <!-- Iterate over keywords -->
          <tbody
            class="w-full"
            *ngFor="let keyword of filteredWPS; let i = index"
          >
            <tr *ngIf="keyword.is_custom === 1">
              <td class="w-[5%] text-center">
                <!-- Radio button replacing checkbox -->
                <input
                  type="radio"
                  style="box-shadow: none"
                  class="checkbox-header"
                  [(ngModel)]="selectedKeyword"
                  [value]="keyword"
                />
              </td>
              <td
                class="w-[25%] pl-[23.08px] text-left"
                style="color: black; font-size: large"
              >
                {{ keyword.name }}<br />

                <!-- Show related WPSI items for the keyword -->
                <div *ngFor="let wps_item of keyword.relatedItems">
                  <tr class="ml-[50px]">
                    <td class="pl-[50px]">{{ wps_item.name }}</td>
                  </tr>
                </div>
              </td>
              <td></td>
              <td
                class="w-[70%] pl-[23.08px] text-right items-right justify-right"
              >
                <button
                  class="add_item"
                  (click)="openDialog('0ms', '0ms', keyword.id)"
                >
                  + Add Items
                </button>
              </td>
            </tr>
            <tr></tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="w-[100%] flex justify-end mb-[1rem] mt-[20px]">
      <button class="save-button" (click)="navigateCostEstimation()">
        Save
      </button>
    </div>

    <!-- <div
      class="btn-section card-container shadow-custom bg-white rounded-lg mb-0 mr-5"
    > -->
    <!-- <button class="save-next-button" (click)="navigateCostEstimation()">
        Save
      </button>
      <button class="back-button">Back</button> -->
    <!-- <button class="save-next-button" (click)="navigateCostEstimation()">
      Save & Next
    </button> -->
    <!-- <button class="save-button">Save</button> -->
    <!-- <button class="back-button" (click)="navigatetoPreviousPage()">Back</button> -->
    <!-- </div> -->
  </div>
</div>
